<template>
  <b-container>

  <b-row class="pt-4">
        <b-col>
          <h3>{{$t('label.submitApplication')}}</h3>
        </b-col>
      </b-row>
  
  <!-- <h1 class="text-center pt-4 pb-4">{{ from !== 'missingDoc' ? $t('label.submitApplication') : $t('label.missingDoc')}}</h1> -->

  <div class="mt-2">
      <AlertSelectedUnit :selectedUnit="selectedUnit"/>
    </div>

  <b-form @submit="onSubmit">
    
    <hr />

    <b-alert show>
      <h5 class="alert-heading">{{$t('label.infoUpload')}}</h5>
        <hr/>
      
      <div>{{$t('info.requiredId')}}</div>
      <div>{{$t('info.requiredProof')}}</div>
      <div>{{$t('info.requiredDoc')}}</div>
      <div v-if="from === 'missingDoc'">
        <hr/>
        <div>{{$t('info.missingDoc')}}</div>
      </div>
    </b-alert>

    <!-- Applicant1 -->

    <!-- Id -->
    <h5>{{$t('label.principalApplicant')}}</h5> 
    <b-row class="mt-2" >   
        
        <b-col sm class="mt-4">
            <b-form-input v-model.trim="$v.applicant1.Fname.$model" :placeholder="'* '+$t('label.fname')" readonly></b-form-input>
            <div class="text-danger" v-if="!$v.applicant1.Fname.required && $v.applicant1.Fname.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.applicant1.Fname.maxLength && $v.applicant1.Fname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
        </b-col>
        <b-col sm class="mt-4">
            <b-form-input v-model.trim="$v.applicant1.Lname.$model" :placeholder="'* '+$t('label.lname')" readonly></b-form-input>
            <div class="text-danger" v-if="!$v.applicant1.Lname.required && $v.applicant1.Lname.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.applicant1.Lname.maxLength && $v.applicant1.Lname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
        </b-col>
        <b-col v-if="from !== 'missingDoc'" sm class="mt-4">
           <b-form-select v-model.trim="$v.applicant1.type.$model" :options="applicantsType"></b-form-select>
          <div class="text-danger" v-if="!$v.applicant1.type.required && $v.applicant1.type.$dirty">{{ $t('info.required') }}</div>
        </b-col>
    </b-row>

    <b-row class="mt-2" >  
        <b-col sm class="mt-4">
            <p>* {{$t('label.Id')}} :</p>
            <b-form-file
              v-model.trim="applicant1.idDoc"
              name="applicant1.idDoc"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant1.idDoc"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div v-if="from !== 'missingDoc'">
              <div class="text-danger" v-if="!$v.applicant1.idDoc.required && $v.applicant1.idDoc.$dirty">{{ $t('info.required') }}</div>
             </div>
            <div class="text-danger" v-if="applicant1.errorIdDoc">{{ applicant1.errorIdDoc }}</div>
            <b-button @click="clearFiles('applicant1.idDoc')" size="sm" class="mt-3" :disabled="disabledClear('applicant1.idDoc')">{{ $t('label.clearField') }}</b-button>
        </b-col>

        <b-col sm class="mt-4">
            <p>* {{$t('label.proof')}} :</p>
            <b-form-file
              v-model.trim="applicant1.proof"
              name="applicant1.proof"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant1.proof"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div v-if="from !== 'missingDoc'">
              <div class="text-danger" v-if="!$v.applicant1.proof.required && $v.applicant1.proof.$dirty">{{ $t('info.required') }}</div>
             </div>
            <div class="text-danger" v-if="applicant1.errorProof">{{ applicant1.errorProof }}</div>
            <b-button @click="clearFiles('applicant1.proof')" size="sm" class="mt-3" :disabled="disabledClear('applicant1.proof')">{{ $t('label.clearField') }}</b-button>
        </b-col>
        <b-col sm class="mt-4">
            <p>{{$t('label.otherDoc')}} :</p>
            <b-form-file
              v-model.trim="applicant1.other"
              name="applicant1.other"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant1.other"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="applicant1.errorOther">{{ applicant1.errorOther }}</div>
            <b-button @click="clearFiles('applicant1.other')" size="sm" class="mt-3" :disabled="disabledClear('applicant1.other')">{{ $t('label.clearField') }}</b-button>
        </b-col>
    </b-row>

    <!-- APPLICANT 2 -->

    <div v-if="applicants[0]">
    <hr />
    <h5>{{$t('label.coloc')}} 1</h5> 
    <b-row class="mt-2" >   
        
        <b-col sm class="mt-4">
            <b-form-input v-model.trim="$v.applicant2.Fname.$model" :placeholder="'* '+$t('label.fname')"></b-form-input>
            <div class="text-danger" v-if="!$v.applicant2.Fname.required && $v.applicant2.Fname.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.applicant2.Fname.maxLength && $v.applicant2.Fname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
        </b-col>
        <b-col sm class="mt-4">
            <b-form-input v-model.trim="$v.applicant2.Lname.$model" :placeholder="'* '+$t('label.lname')"></b-form-input>
            <div class="text-danger" v-if="!$v.applicant2.Lname.required && $v.applicant2.Lname.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.applicant2.Lname.maxLength && $v.applicant2.Lname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
        </b-col>
        <b-col sm class="mt-4">
           <b-form-select v-model.trim="$v.applicant2.type.$model" :options="applicantsType"></b-form-select>
          <div class="text-danger" v-if="!$v.applicant2.type.required && $v.applicant2.type.$dirty">{{ $t('info.required') }}</div>
        </b-col>
    </b-row>

    <b-row class="mt-2" >  
        <b-col sm class="mt-4">
            <p>* {{$t('label.Id')}} :</p>
            <b-form-file
              v-model.trim="applicant2.idDoc"
              name="applicant2.idDoc"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant2.idDoc"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="!$v.applicant2.idDoc.required && $v.applicant2.idDoc.$dirty">{{ $t('info.required') }}</div>
            <div class="text-danger" v-if="applicant2.errorIdDoc">{{ applicant2.errorIdDoc }}</div>
            <b-button @click="clearFiles('applicant2.idDoc')" size="sm" class="mt-3" :disabled="disabledClear('applicant2.idDoc')">{{ $t('label.clearField') }}</b-button>
        </b-col>

        <b-col sm class="mt-4">
            <p>* {{$t('label.proof')}} :</p>
            <b-form-file
              v-model.trim="applicant2.proof"
              name="applicant2.proof"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant2.proof"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="!$v.applicant2.proof.required && $v.applicant2.proof.$dirty">{{ $t('info.required') }}</div>
            <div class="text-danger" v-if="applicant2.errorProof">{{ applicant2.errorProof }}</div>
            <b-button @click="clearFiles('applicant2.proof')" size="sm" class="mt-3" :disabled="disabledClear('applicant2.proof')">{{ $t('label.clearField') }}</b-button>
        </b-col>
        <b-col sm class="mt-4">
            <p>{{$t('label.otherDoc')}} :</p>
            <b-form-file
              v-model.trim="applicant2.other"
              name="applicant2.other"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant2.other"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="applicant2.errorOther">{{ applicant2.errorOther }}</div>
            <b-button @click="clearFiles('applicant2.other')" size="sm" class="mt-3" :disabled="disabledClear('applicant2.other')">{{ $t('label.clearField') }}</b-button>
        </b-col>
    </b-row>

    <b-button @click="removeApplicant(0)" size="sm" variant="danger" class="mt-3">{{ $t('label.removeApplicant') }}</b-button>

    </div>

    <!-- APPLICANT 3 -->

    <div v-if="applicants[1]">
    <hr />
    <h5>{{$t('label.coloc')}} 2</h5>  

    <b-row class="mt-2" >   
        
        <b-col sm class="mt-4">
            <b-form-input v-model.trim="$v.applicant3.Fname.$model" :placeholder="'* '+$t('label.fname')"></b-form-input>
            <div class="text-danger" v-if="!$v.applicant3.Fname.required && $v.applicant3.Fname.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.applicant3.Fname.maxLength && $v.applicant3.Fname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
        </b-col>
        <b-col sm class="mt-4">
            <b-form-input v-model.trim="$v.applicant3.Lname.$model" :placeholder="'* '+$t('label.lname')"></b-form-input>
            <div class="text-danger" v-if="!$v.applicant3.Lname.required && $v.applicant3.Lname.$dirty">{{ $t("info.required") }}</div>
            <div class="text-danger" v-if="!$v.applicant3.Lname.maxLength && $v.applicant3.Lname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
        </b-col>
        <b-col sm class="mt-4">
           <b-form-select v-model.trim="$v.applicant3.type.$model" :options="applicantsType"></b-form-select>
          <div class="text-danger" v-if="!$v.applicant3.type.required && $v.applicant3.type.$dirty">{{ $t('info.required') }}</div>
        </b-col>
    </b-row>

    <b-row class="mt-2" >  
        <b-col sm class="mt-4">
            <p>* {{$t('label.Id')}} :</p>
            <b-form-file
              v-model.trim="applicant3.idDoc"
              name="applicant3.idDoc"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant3.idDoc"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="!$v.applicant3.idDoc.required && $v.applicant3.idDoc.$dirty">{{ $t('info.required') }}</div>
            <div class="text-danger" v-if="applicant3.errorIdDoc">{{ applicant3.errorIdDoc }}</div>
            <b-button @click="clearFiles('applicant3.idDoc')" size="sm" class="mt-3" :disabled="disabledClear('applicant3.idDoc')">{{ $t('label.clearField') }}</b-button>
        </b-col>

        <b-col sm class="mt-4">
            <p>* {{$t('label.proof')}} :</p>
            <b-form-file
              v-model.trim="applicant3.proof"
              name="applicant3.proof"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant3.proof"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="!$v.applicant3.proof.required && $v.applicant3.proof.$dirty">{{ $t('info.required') }}</div>
            <div class="text-danger" v-if="applicant3.errorProof">{{ applicant3.errorProof }}</div>
            <b-button @click="clearFiles('applicant3.proof')" size="sm" class="mt-3" :disabled="disabledClear('applicant3.proof')">{{ $t('label.clearField') }}</b-button>
        </b-col>
        <b-col sm class="mt-4">
            <p>{{$t('label.otherDoc')}} :</p>
            <b-form-file
              v-model.trim="applicant3.other"
              name="applicant3.other"
              :lang="this.$i18n.locale"
              class="overflowwrap"
              ref="applicant3.other"
              :placeholder="$t('label.choosefile')"
              @change="validateMultipleFile"
              :file-name-formatter="formatNames"
              multiple
            ></b-form-file>
            <div class="text-danger" v-if="applicant3.errorOther">{{ applicant3.errorOther }}</div>
            <b-button @click="clearFiles('applicant3.other')" size="sm" class="mt-3" :disabled="disabledClear('applicant3.other')">{{ $t('label.clearField') }}</b-button>
        </b-col>
    </b-row>

    <b-button @click="removeApplicant(1)" size="sm" variant="danger" class="mt-3">{{ $t('label.removeApplicant') }}</b-button>

    </div>

     <div v-if="spinner" class="text-center">
      <b-spinner style="width: 3rem; height: 3rem;" variant="success" label="Spinning" disabled="labelStatus"></b-spinner>
      </div>
    
    <div v-if="from === 'applicant'"><b-button @click="addApplicant" size="sm" variant="success" class="mt-4">{{ $t('label.addApplicant') }}</b-button></div>

    <hr />

    <div><b-button class="mt-4 text-center" type="submit" variant="success" :disabled="disabled">{{ $t("label.submit") }}</b-button></div>

    <div v-if="success" class="pt-4">
      <b-alert show variant="success">
        <p>{{ $t("info.submitDoc") }}</p>
      </b-alert>
    </div>

    <div v-if="nbOfMissingDoc" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ $t("info.nbOfMissingDoc") }}</p>
      </b-alert>
    </div>

    <div v-if="validationStatus !== 0" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ formatValidationStatus(validationStatus) }}</p>
      </b-alert>
    </div>

    <div v-if="error" class="pt-4">
      <b-alert show variant="danger">
        <p>{{ error }}</p>
      </b-alert>
    </div>

  </b-form>
</b-container>
</template>

<script>
import axios from 'axios';
import { required, maxLength} from 'vuelidate/lib/validators';
import { globalF } from './Helpers';
import AlertSelectedUnit from './AlertSelectedUnit';

export default {
mixins: [globalF],
props: ["btnNextStep", "from"],
data() {
  return {
        validationStatus: 0,
        applicants: [],
        nbOfMissingDoc: false,
        applicant1: {
          Fname: this.getData('fname', "", 1, this.from),
          Lname: this.getData('lname', "", 1, this.from),
          type: null,
          idDoc : null,
          errorIdDoc: "",
          proof: null,
          errorProof: "",
          other: null,
          errorOther: ""
        },
        applicant2: {
          Fname: "",
          Lname: "",
          type: null,
          idDoc : null,
          errorIdDoc: "",
          proof: null,
          errorProof: "",
          other: null,
          errorOther: "",
        },
        applicant3: {
          Fname: "",
          Lname: "",
          type: null,
          idDoc : null,
          errorIdDoc: "",
          proof: null,
          errorProof: "",
          other: null,
          errorOther: "",
        },
        success: false,
        error: "",
        disabled: false,
        spinner: false,
    }
},
validations() {
  let form = {
      applicant1: { idDoc: {required}, proof: {required}, Fname: {required, maxLength: maxLength(50)}, Lname: {required, maxLength: maxLength(50)}, type: {required} },   
  }
  if (this.from === 'missingDoc') {
      form.applicant1 = { Fname: {required, maxLength: maxLength(50)}, Lname: {required, maxLength: maxLength(50)} }
  }
  if (this.applicants[0]) {
    form.applicant2 = {Fname: {required, maxLength: maxLength(50)}, Lname: {required, maxLength: maxLength(50)}, type: {required}, idDoc: {required}, proof: {required}};
  }
  

  if (this.applicants[1]) {
    form.applicant3 = {Fname: {required, maxLength: maxLength(50)}, Lname: {required, maxLength: maxLength(50)}, type: {required}, idDoc: {required}, proof: {required}};
  }
    
  return form;
},
computed: {
  url: function () {
    let urls = this.$store.getters.getUrlsList;
    return urls[process.env.VUE_APP_WHERE].json;
  },
  applicantsType: function () {
    let lg = this.$i18n.locale;

    let fromGetter = this.$store.getters.getApplicantsType;
    let appTypeList = [];
    if (this.from === "endorser") {
      appTypeList = fromGetter.filter(a => a.Id === 2);
    }
    else {
       appTypeList = fromGetter.filter(a => a.Id !== 2);
    }
    
    let fields = this.formatBselect(appTypeList, lg);

    fields.unshift({value: null, text: '* '+this.$t('label.applicantType')});

    return fields;
  },
  selectedUnit: function () {

      let buldingsList = this.$store.getters.getBuildings;
      let prospectsUnits = this.$store.getters.getProspectsUnits;
      let selected = [];

      if (prospectsUnits.length > 0) {
        selected = prospectsUnits;
      }
      else {
        let processData = this.getUserProcessData(0);
        if (processData && processData.hasOwnProperty('selected')) {
          selected = processData.selected;
        }
      }

      let processData1 = this.getUserProcessData(1);
      let from = "";
      let to = "";

      if (processData1 && processData1.hasOwnProperty('from') && processData1.hasOwnProperty('to')) {
          from = processData1.from;
          to = processData1.to;
      }

      let buildFormat = {};
      if (selected.length > 0) {
        let build = buldingsList.find(b => b.NOCIE === selected[0].NOCIE && b.NODIV === selected[0].NODIV && b.Immeuble.trim() === selected[0].IMMEUBLE.trim());
        buildFormat.name = build.NOMDIV+ " ("+  build.Street + ", " + build.City + ", " + build.Province+" )";
        buildFormat.unit = " # " +selected[0].UNITE;
        buildFormat.specs = {NBPIECE: selected[0].NBPIECE, publicUnitPrice: selected[0].publicUnitPrice, DATEENT: from, DATEEND: to};
      }
      
      return buildFormat;
    },
 },
methods:{ 
  formatValidationStatus: function (status) {
    let value = this.$t('info.errorgeneric');

    if (status === 1) {
      value = this.$t('info.activeSession');
    }

    if (status === 2 || status === 3 || status === 4) {
      value = this.$t('info.unitNotAvailable');
    }

    return value;

  },
  getProcessData(int, type) {
    let processData = [];
    if (type === "endorser") {
      processData = this.$store.getters.getEndorserData;
    }
    else {
      processData = this.$store.getters.getProcessData;
    }
    let step0data = processData[int];
    return step0data;
 },
 getUserProcessData(int) {

    let processData = this.$store.getters.getProcessData;
    
    let step0data = processData[int];
    return step0data;

  },
  getData(property, defaultType, int, type) {
    let processData = this.getProcessData(int, type);
    let value = defaultType;
    if (processData && processData.hasOwnProperty(property)) {
      value = processData[property];
    }
    return value;
  },
  formatAddress: function () {
      let processData = this.getProcessData(0, 'applicant');
      let selected = "";
      if (processData && processData.hasOwnProperty('building')) {
            selected = processData.building.NOMDIV;
        }
        return selected;
    },
  addApplicant: function () {
    if (this.applicants.length < 2) {
      this.applicants.push(1);
    }
  },  
  removeApplicant: function (ind) {
    this.applicants.splice(ind, 1);
  },
  disabledClear: function (form) {
    //APPLICANTS1
    if (form === 'applicant1.idDoc') {
      return this.applicant1.idDoc ? false : true;
    }
    if (form === 'applicant1.proof') {
      return this.applicant1.proof ? false : true;
    }
    if (form === 'applicant1.other') {
      return this.applicant1.other ? false : true;
    }

    //APPLICANTS2
    if (form === 'applicant2.idDoc') {
      return this.applicant2.idDoc ? false : true;
    }
    if (form === 'applicant2.proof') {
      return this.applicant2.proof ? false : true;
    }
    if (form === 'applicant2.other') {
      return this.applicant2.other ? false : true;
    }

    //APPLICANTS3
    if (form === 'applicant3.idDoc') {
      return this.applicant3.idDoc ? false : true;
    }
    if (form === 'applicant3.proof') {
      return this.applicant3.proof ? false : true;
    }
    if (form === 'applicant3.other') {
      return this.applicant3.other ? false : true;
    }
    
  },
  clearFiles(ref) {
    //APPPLICANT1
    if (ref === 'applicant1.idDoc') {
        this.$refs['applicant1.idDoc'].reset();
        this.applicant1.idDoc = null;
        this.applicant1.errorIdDoc = "";
      }
    if (ref === 'applicant1.proof') {
        this.$refs['applicant1.proof'].reset();
        this.applicant1.proof = null;
        this.applicant1.errorProof = "";
      }
    if (ref === 'applicant1.other') {
        this.$refs['applicant1.other'].reset();
        this.applicant1.other = null;
        this.applicant1.errorOther = "";
      }

    //APPPLICANT2
    if (ref === 'applicant2.idDoc') {
        this.$refs['applicant2.idDoc'].reset();
        this.applicant2.idDoc = null;
        this.applicant2.errorIdDoc = "";
      }
    if (ref === 'applicant2.proof') {
        this.$refs['applicant2.proof'].reset();
        this.applicant2.proof = null;
        this.applicant2.errorProof = "";
      }
    if (ref === 'applicant2.other') {
        this.$refs['applicant2.other'].reset();
        this.applicant2.other = null;
        this.applicant2.errorOther = "";
      }

      //APPPLICANT3
    if (ref === 'applicant3.idDoc') {
        this.$refs['applicant3.idDoc'].reset();
        this.applicant3.idDoc = null;
        this.applicant3.errorIdDoc = "";
      }
    if (ref === 'applicant3.proof') {
        this.$refs['applicant3.proof'].reset();
        this.applicant3.proof = null;
        this.applicant3.errorProof = "";
      }
    if (ref === 'applicant3.other') {
        this.$refs['applicant3.other'].reset();
        this.applicant3.other = null;
        this.applicant3.errorOther = "";
      }
  },
  validateMultipleFile(event) {
      let myfiles = event.target.files;
      let filename = event.target.name;

      //APPLICANT1
      if (filename === "applicant1.idDoc") {
          this.applicant1.errorIdDoc = "";
      }
      if (filename === "applicant1.proof") {
          this.applicant1.errorProof = "";
      }
      if (filename === "applicant1.other") {
          this.applicant1.errorOther = "";
      }

      //APPLICANT2
      if (filename === "applicant2.idDoc") {
          this.applicant2.errorIdDoc = "";
      }
      if (filename === "applicant2.proof") {
          this.applicant2.errorProof = "";
      }
      if (filename === "applicant2.other") {
          this.applicant2.errorOther = "";
      }
      
      //APPLICANT3
      if (filename === "applicant3.idDoc") {
          this.applicant3.errorIdDoc = "";
      }
      if (filename === "applicant3.proof") {
          this.applicant3.errorProof = "";
      }
      if (filename === "applicant3.other") {
          this.applicant3.errorOther = "";
      }
      
      this.validateFilesLength(myfiles, filename);
      this.validateFilesType(myfiles, filename);

    },
    validateFilesLength: function (myfiles, filename) {
        if (myfiles.length > 3) {
        
          //APPLICANT1
          if (filename === "applicant1.idDoc") {
            this.applicant1.errorIdDoc = this.$t("info.limitNumberOfFiles");
          }
          if (filename === "applicant1.proof") {
            this.applicant1.errorProof = this.$t("info.limitNumberOfFiles");
          }
          if (filename === "applicant1.other") {
            this.applicant1.errorOther = this.$t("info.limitNumberOfFiles");
          }
          
           //APPLICANT2
          if (filename === "applicant2.idDoc") {
            this.applicant2.errorIdDoc = this.$t("info.limitNumberOfFiles");
          }
          if (filename === "applicant2.proof") {
            this.applicant2.errorProof = this.$t("info.limitNumberOfFiles");
          }
          if (filename === "applicant2.other") {
            this.applicant2.errorOther = this.$t("info.limitNumberOfFiles");
          }
          
           //APPLICANT3
          if (filename === "applicant3.idDoc") {
            this.applicant3.errorIdDoc = this.$t("info.limitNumberOfFiles");
          }
          if (filename === "applicant3.proof") {
            this.applicant3.errorProof = this.$t("info.limitNumberOfFiles");
          }
          if (filename === "applicant3.other") {
            this.applicant3.errorOther = this.$t("info.limitNumberOfFiles");
          }
        }
    },
    validateFilesType: function (myfiles, filename) {
      let typeList = ["application/pdf", "image/jpeg", "image/jpg", "image/png"];
        for (let i = 0; i < myfiles.length; i++) {
            let found = typeList.includes(myfiles[i].type);
            if (!found || myfiles[i].size > 4000000) {
              
              //APPLICANT1
              if (filename === "applicant1.idDoc") {
                this.applicant1.errorIdDoc = this.$t("info.invalidFileType");
              }
              if (filename === "applicant1.proof") {
                this.applicant1.errorProof = this.$t("info.invalidFileType");
              }
              if (filename === "applicant1.other") {
                this.applicant1.errorOther = this.$t("info.invalidFileType");
              }

              //APPLICANT2
              if (filename === "applicant2.idDoc") {
                this.applicant2.errorIdDoc = this.$t("info.invalidFileType");
              }
              if (filename === "applicant2.proof") {
                this.applicant2.errorProof = this.$t("info.invalidFileType");
              }
              if (filename === "applicant2.other") {
                this.applicant2.errorOther = this.$t("info.invalidFileType");
              }

              //APPLICANT3
              if (filename === "applicant3.idDoc") {
                this.applicant3.errorIdDoc = this.$t("info.invalidFileType");
              }
              if (filename === "applicant3.proof") {
                this.applicant3.errorProof = this.$t("info.invalidFileType");
              }
              if (filename === "applicant3.other") {
                this.applicant3.errorOther = this.$t("info.invalidFileType");
              }
            }
          }
    },
    validateMissingFiles: function () {
    let pass = true;

    if (this.applicant1.idDoc === null && this.applicant1.proof === null && this.applicant1.other === null) {
      pass = false;
    }
    
    return pass;
  },
    formatNames(files) {
        if (files.length === 1) {
          return files[0].name
        } else {
          return `${files.length} files selected`
        }
    },
    onSubmit(evt) {
      evt.preventDefault(); 
      this.success = false;
      this.error = "";
      this.validationStatus = 0;
      this.$v.$touch();
        if (!this.$v.$invalid) {
          this.spinner = true;
          let pass = false;
          if (this.from === 'missingDoc') {
            pass = this.validateMissingFiles();
          }
          else {
            pass = this.validateApplicants();
          }          
          if (pass) {
            if (this.from === 'endorser' || this.from === 'missingDoc') {
              this.prepareRequest(null, this.applicant1, 1);  
            }
            else {
              this.validateProspectAndUnit();
            }
          }
        }
    },
    validateProspectAndUnit: function () {
      //this.spinner = true;
      let selected = this.getData('selected', [], 0, 'applicant');

      if (selected.length > 0) {
        let obj = {
          NOCIE: selected[0].NOCIE,
          NODIV: selected[0].NODIV,
          IMMEUBLE: selected[0].IMMEUBLE,
          UNITE: selected[0].UNITE,
          email: this.getData('email', "", 1, 'applicant')
        }

        axios.post(this.url, {request: "validateProspectAndUnit", form: obj  }, { headers: {'Content-Type': 'application/json'}})
                .then((response)  => {
                    if (response.data.validationStatus === 0) {                      
                        this.addProspectAndUnits(response.data.oldProspect);
                    }
                    else {
                        this.validationStatus = response.data.validationStatus;
                        this.spinner = false;
                    }
                })
                .catch(()  => {
                    this.error = this.$t('info.errorgeneric');
                    this.spinner = false;
                });
      }
    },
    addProspectAndUnits: function (oldProspect) {
      let selected = this.getData('selected', [], 0, 'applicant');
      //prospect = Fname, Lname, Tel, Email, Communication, Gender

      if (selected.length > 0) {
        let obj = {
          oldProspect: oldProspect,
          buildingunit: selected,
          email: this.getData('email', "", 1, 'applicant'),
          fname: this.getData('fname', "", 1, 'applicant'),
          lname : this.getData('lname', "", 1, 'applicant'),
          tel : this.getData('cell', "", 1, 'applicant'),
          communication : this.$i18n.locale,
          description: "",
          reference: 11, //Site Web Cogir
          gender: this.getData('gender', "", 1, 'applicant')
        }

        axios.post(this.url, {request: "addProspectAndUnits", form: obj  }, { headers: {'Content-Type': 'application/json'}})
                .then((response)  => {
                    if (response.data.Status === 0) {
                        this.prepareRequest(response.data.IdSession, this.applicant1, 1);    
                        //this.spinner = false;                   
                    }
                    else if(response.data.Status === 4) {
                      this.validationStatus = response.data.status;
                    }
                    else {
                        this.error = this.$t('info.errorgeneric');
                        this.spinner = false;
                    }
                })
                .catch(()  => {
                    this.error = this.$t('info.errorgeneric');
                    this.spinner = false;
                });
      }
    },
    validateApplicants: function () {
      let pass1 = false;
      let pass2 = this.applicants[0] ? false : true;
      let pass3 = this.applicants[1] ? false : true;

      if (this.applicant1.errorIdDoc === "" && this.applicant1.errorProof === "" && this.applicant1.errorOther === "") {
        pass1 = true;
      }
      if (this.applicants[0] && this.applicant2.errorIdDoc === "" && this.applicant2.errorProof === "" && this.applicant2.errorOther === "") {
        pass2 = true;
      }
      if (this.applicants[1] && this.applicant3.errorIdDoc === "" && this.applicant3.errorProof === "" && this.applicant3.errorOther === "") {
        pass3 = true;
      }

      if (pass1 && pass2 && pass3) {
        return true;
      }
      else {
        return false;
      }
    },
    prepareRequest: function (IdSession, applicant, appNumber) {

        let formData = new FormData();
        let from = this.getData('from', "", 1, 'applicant');
        let selected = this.getData('selected', [], 0, 'applicant');

        if (this.from === 'endorser' || this.from === 'missingDoc') {
          let action = this.from === 'endorser' ? 2 : 1;
          formData.append('request', 'updateApplicationsDoc');
          formData.append('action', action);
          formData.append('applicantType', applicant.type);

          let prospectSession = this.$store.getters.getProspectSession;
          console.log(prospectSession);
          let usnotification = 4;
          let crnotification = 3;

          if (prospectSession.length > 0) {
            if (prospectSession[0].NeedValidation === 1) {
              usnotification = 12;
              crnotification = 1;
            }
          }

          formData.append('CreditNotification', crnotification);
          formData.append('UserNotification', usnotification);
        
          formData.append('NOCIE', selected[0].NOCIE);
          formData.append('NODIV', selected[0].NODIV); 

          if (applicant.idDoc) {
            for (let i = 0; i < applicant.idDoc.length; i ++) {
              formData.append('end2['+ i +']', applicant.idDoc[i]);
            }
          }
          if (applicant.proof) {
            for (let i = 0; i < applicant.proof.length; i ++) {
              formData.append('end3['+ i +']', applicant.proof[i]);
            }
          }
          if (applicant.other) {
            for (let i = 0; i < applicant.other.length; i ++) {
              formData.append('end4['+ i +']', applicant.other[i]);
            }
          }
          
          if (appNumber === 1) {
            this.sendFormData(IdSession, formData, 1);
          }
        }

        else {

          let folderA = "Applicant";

          if (appNumber !== 1) {
            folderA = "Applicant"+appNumber;
          }

          //formData.append('user', user.Id);  
          formData.append('request', 'setApplication');             
          formData.append('applicantType', applicant.type);
          formData.append('fname', applicant.Fname);
          formData.append('lname', applicant.Lname);
          formData.append('IdSession', IdSession);
          formData.append('rentedDate', from);

          formData.append('NOCIE', selected[0].NOCIE);
          formData.append('NODIV', selected[0].NODIV); 
          formData.append('IMMEUBLE', selected[0].IMMEUBLE); 
          formData.append('UNITE', selected[0].UNITE);
          formData.append('DATEDEP', selected[0].DATEDEP); 
          formData.append('LOYACTU', selected[0].LOYACTU); 
          formData.append('LOYACTUNITE', selected[0].LOYACTUNITE); 
          formData.append('LOYEVEN', selected[0].LOYEVEN); 
          formData.append('LOYPROJ', selected[0].LOYPROJ);
          formData.append('VALMARCHE', selected[0].VALMARCHE);  
          formData.append('publicUnitPrice', selected[0].publicUnitPrice); 
          formData.append('NBPIECE', selected[0].NBPIECE); 
          formData.append('SFICIE', selected[0].SFICIE);  
          
          formData.append('folderApplicant', folderA);
          
          for (let i = 0; i < applicant.idDoc.length; i ++) {
            formData.append('doc2['+ i +']', applicant.idDoc[i]);
          }
          
          for (let i = 0; i < applicant.proof.length; i ++) {
            formData.append('doc3['+ i +']', applicant.proof[i]);
          }
          
          if (applicant.other) {
            for (let i = 0; i < applicant.other.length; i ++) {
              formData.append('doc4['+ i +']', applicant.other[i]);
            }
          }

          if (appNumber === 1) {
            this.sendFormData(IdSession, formData, 1);
          }
          if (appNumber === 2) {
            this.sendFormData(IdSession, formData, 2);
          }
          if (appNumber === 3) {
            this.sendFormData(IdSession, formData, 3);
          }
      }  
    },
    sendFormData: function (IdSession, formData, applicant) {
          //this.spinner = true;
          //let promise = this.setAxios('Step2');
            //promise.then(() => {
            let urls = this.$store.getters.getUrlsList;
            let urlFormData =  urls[process.env.VUE_APP_WHERE].formdata;

            axios({
              method: 'post',
              url: urlFormData,
              data: formData,
              config: { headers: {'Content-Type': 'multipart/form-data' }}
              })
              .then((resp) => {
                let res = resp.data;
                if (res.status === 0) {
                  if (applicant === 1 && this.applicants[0]) {
                    this.prepareRequest(IdSession, this.applicant2, 2);
                  }
                  else if (applicant === 2 && this.applicants[1]) {
                    this.prepareRequest(IdSession, this.applicant3, 3);
                  }
                  else {
                    this.spinner = false;
                    if (this.from === 'missingDoc') {
                      this.success = true;
                    }
                    else {
                      window.location.reload(true);
                    }
                  }
                }
                else {
                  if (res.status === 2 && this.from === 'missingDoc') {
                    this.nbOfMissingDoc = true;
                  }
                  else {
                    this.error = this.$t('info.errorgeneric');
                    this.spinner = false;
                  }
                }
              })
              .catch(() => {
                this.error = this.$t('info.errorgeneric');
                this.spinner = false;
              })
            //});    
     }
  },
   components: {
     AlertSelectedUnit
  }
}
</script>